import React, { useMemo } from 'react';
import { IItemForGetShortInfo } from 'types';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import style from './Info.module.scss';

interface IProps {
	customerName: string;
	fetchedRestaurants: IItemForGetShortInfo[];
	IDSelectedRestaurantOnRestPropsPage: Nullable<string>;
	price: Nullable<number>;
	supplementPrice: Nullable<number>;
	quantityMaxLimit: Nullable<number>;
	activationSchedule: string;
	deactivationSchedule: string;
	inStop: boolean;
	isRestricted: boolean;
	isPreselected: boolean;
	forceDisable: boolean;
	hasPortions: boolean;
}

export const Info: React.FC<IProps> = React.memo(
	({
		customerName,
		fetchedRestaurants,
		IDSelectedRestaurantOnRestPropsPage,
		price,
		supplementPrice,
		quantityMaxLimit,
		activationSchedule,
		deactivationSchedule,
		inStop,
		isRestricted,
		isPreselected,
		forceDisable,
		hasPortions,
	}) => {
		const { t } = useTranslation('form');
		const inStopValue = inStop ? t('yes') : t('no');
		const isRestrictedValue = isRestricted ? t('yes') : t('no');
		const isPreselectedValue = isPreselected ? t('yes') : t('no');
		const forceDisableValue = forceDisable ? t('yes') : t('no');

		const restaurantName = useMemo(() => {
			return (
				fetchedRestaurants.find((restaurant) => restaurant.id === IDSelectedRestaurantOnRestPropsPage)?.name ||
				'-'
			);
		}, [fetchedRestaurants, IDSelectedRestaurantOnRestPropsPage]);

		return (
			<div className={style.container}>
				<div className={style.item}>
					<FullInfoField
						containerClassName={style.input}
						label="customerLabel"
						value={customerName}
						useInForm={true}
					/>
					<FullInfoField
						containerClassName={style.input}
						label="restaurantLabel"
						value={restaurantName}
						useInForm={true}
					/>
				</div>
				<div className={style.item}>
					{!hasPortions && (
						<>
							<FullInfoField
								containerClassName={style.input}
								label="signedPriceLabel"
								value={price}
								useInForm={true}
							/>
							<FullInfoField
								containerClassName={style.input}
								label="signedSupplementPriceLabel"
								value={supplementPrice}
								useInForm={true}
							/>
						</>
					)}

					<FullInfoField
						containerClassName={style.input}
						label="maxLimitOfQuantityLabel"
						value={quantityMaxLimit}
						useInForm={true}
					/>
				</div>
				<div className={style.item}>
					<FullInfoField
						containerClassName={style.input}
						label="activationScheduleLabel"
						value={activationSchedule}
						useInForm={true}
					/>
					<FullInfoField
						containerClassName={style.input}
						label="deactivationScheduleLabel"
						value={deactivationSchedule}
						useInForm={true}
					/>
				</div>
				<div className={style.item}>
					<FullInfoField
						containerClassName={style.input}
						label="inStopLabel"
						value={inStopValue}
						prefixIcon="asCheckbox"
						prefixIconName={inStop ? 'checkMark' : 'crossMark'}
						prefixIconIsChecked={inStop}
						useInForm={true}
					/>
					<FullInfoField
						containerClassName={style.input}
						label="isRestrictedLabel"
						value={isRestrictedValue}
						prefixIcon="asCheckbox"
						prefixIconName={isRestricted ? 'checkMark' : 'crossMark'}
						prefixIconIsChecked={isRestricted}
						useInForm={true}
					/>
					<FullInfoField
						containerClassName={style.input}
						label="isPreselectedLabel"
						value={isPreselectedValue}
						prefixIcon="asCheckbox"
						prefixIconName={isPreselected ? 'checkMark' : 'crossMark'}
						prefixIconIsChecked={isPreselected}
						useInForm={true}
					/>
					<FullInfoField
						containerClassName={style.input}
						label="isForceDisabledLabel"
						value={forceDisableValue}
						prefixIcon="asCheckbox"
						prefixIconName={forceDisable ? 'checkMark' : 'crossMark'}
						prefixIconIsChecked={forceDisable}
						useInForm={true}
					/>
				</div>
			</div>
		);
	},
);
